import { compose } from 'redux';
import { connect } from 'react-redux';
import MultiChoiceReadingCheckCard from './MultiChoiceReadingCheckCard';
import { getTrcInstruction, getTrcCaption } from '../../troConstants';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import { narrateReset, stopAudio, setCaption } from '../../../common/audio/audioActions';
import {
    unmountScreen,
    hideSpinner,
    setShouldDisplayCaption,
} from '../../../common/screen/screenActions';
import {
    narrateScreen,
    setPassedMultipleChoiceReadCheck,
    setdidAttemptMultiChoiceReadingCheckCheck,
    patchDiscontinueResult,
} from '../../trcActions';
import { trackPassedReadingCheck, trackTROFailedMultiChoiceReadingCheck } from '../../trcReporting';
import selectors from '../../../rootSelectors';
import {
    clearMicTestAttemptCount,
    clearRecordedResult,
} from '../../../common/recording/recordingActions';
import { setVerificationResult, setVerificationStatus } from '../../../common/api/trcoActions';
import { playAvatarAudio, setAvatarInstructions } from '../../../common/avatar/avatarActions';
import { VERIFICATION_STATUS } from '../instructions/TROInstructionsConstants';
import { getStudentResults } from '../../../common/api/resultStudentActions';

const troMultiChoiceReadingCheckInstructionsInstruction = 'troMultiChoiceReadingCheckInstructions';
const troMultiChoiceReadingCheckSentenceInstruction = 'troMultiChoiceReadingCheckSentence';

const mapStateToProps = state => ({
    recordingStream: selectors.getRecordingStream(state),
    isRecordingInProgress: selectors.getIsRecordingInProgress(state),
    verificationStatus: selectors.selectVerificationStatus(state),
    verificationResult: selectors.selectVerificationResult(state),
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isSpinnerVisible: selectors.getIsSpinnerVisible(state),
    didAttemptMultiChoiceReadingCheck: selectors.getDidAttemptMultiChoiceReadingCheck(state),
    passedReadingCheck: selectors.getPassedReadingCheck(state),
    isExternalURLSourcePresent: selectors.getExternalURLSourceStatus(state),
    arLanguage: selectors.getArLanguage(state),
});

const mapDispatchToProps = dispatch => ({
    narrateScreen: (isExternalURLSourcePresent, arLanguage) => {
        const instruction = getTrcInstruction(
            isExternalURLSourcePresent,
            troMultiChoiceReadingCheckInstructionsInstruction,
            arLanguage,
        );
        const caption = getTrcCaption(
            isExternalURLSourcePresent,
            troMultiChoiceReadingCheckInstructionsInstruction,
            arLanguage,
        );
        return dispatch(narrateScreen(instruction, caption));
    },
    cleanup: () => {
        dispatch(clearRecordedResult());
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(unmountScreen());
        dispatch(setVerificationResult({ reset_verification: true }));
        dispatch(setVerificationStatus(VERIFICATION_STATUS.IDLE));
        dispatch(clearMicTestAttemptCount());
    },
    playAvatarAudio: async (isExternalURLSourcePresent, arLanguage) => {
        const readingCheckMultiChoiseAudio = getTrcInstruction(
            isExternalURLSourcePresent,
            troMultiChoiceReadingCheckSentenceInstruction,
            arLanguage,
        );
        const caption = getTrcCaption(
            isExternalURLSourcePresent,
            troMultiChoiceReadingCheckSentenceInstruction,
            arLanguage,
        );
        if (isExternalURLSourcePresent) {
            dispatch(setCaption(caption));
            dispatch(setShouldDisplayCaption(true));
        }
        await dispatch(playAvatarAudio(readingCheckMultiChoiseAudio));
        if (isExternalURLSourcePresent) {
            dispatch(setShouldDisplayCaption(false));
        }
        await dispatch(setAvatarInstructions(readingCheckMultiChoiseAudio));
        return Promise.resolve();
    },
    setPassedMultipleChoiceReadCheck: async isPass => {
        await dispatch(setPassedMultipleChoiceReadCheck(isPass));
        await dispatch(setdidAttemptMultiChoiceReadingCheckCheck());
    },
    patchDiscontinueResult: async () => {
        try {
            await dispatch(patchDiscontinueResult());
            await dispatch(getStudentResults());
        } finally {
            await dispatch(hideSpinner());
        }
    },
    trackPassedReadingCheck: () => dispatch(trackPassedReadingCheck()),
    trackTROFailedMultiChoiceReadingCheck: () => dispatch(trackTROFailedMultiChoiceReadingCheck()),
});

const avatarMapStateToProps = state => ({
    position: AvatarView.Position.MIDDLE_LEFT,
    instructions: getTrcInstruction(
        selectors.getExternalURLSourceStatus(state),
        troMultiChoiceReadingCheckInstructionsInstruction,
        selectors.getArLanguage(state),
    ),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(MultiChoiceReadingCheckCard);
